import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { AnimatedPromise } from "./AnimatedPromise";
import { BRAND } from "@/lib/api";

export const ResultsTopBar = () => {
  const { lang, setLang, t } = useLang();
  return (
    <div data-testid="results-top-bar" className="shrink-0 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[72px] py-2 flex items-center gap-3">
        <Link to="/" data-testid="topbar-logo" className="hidden sm:flex items-center shrink-0">
          <img src={BRAND.logo} alt="Realty" className="h-12 sm:h-16 w-auto" />
        </Link>
        <div className="flex-1 flex justify-center min-w-0">
          <AnimatedPromise align="center" />
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <div data-testid="language-toggle-button" className="flex items-center rounded-full border border-slate-200 bg-slate-50 p-0.5 text-xs font-bold">
            {["ru", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLang(l)}
                className={`px-2.5 sm:px-3 py-1.5 rounded-full transition-all ${
                  lang === l ? "bg-white text-slate-900 shadow-sm" : "text-slate-400 hover:text-slate-600"
                }`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <Link
            to="/post-ad"
            data-testid="post-ad-button"
            className="hidden md:inline-flex items-center rounded-xl bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-sm font-semibold px-4 py-2 transition-colors"
          >
            {t("postAd")}
          </Link>
        </div>
      </div>
    </div>
  );
};
